// Análisis de competencia (migración 20261021a_competitor_reports.sql). Textos y validaciones de la pantalla «Análisis de competencia».

export const MIN_QUERY = 3;
export const MAX_QUERY = 80;
export const MIN_CITY = 2;
export const MAX_CITY = 60;

export const checkRequest = ({ query, city }) => {
  const q = String(query || '').trim();
  const c = String(city || '').trim();
  if (q.length < MIN_QUERY) return 'Escribe el rubro, por ejemplo «barberías».';
  if (q.length > MAX_QUERY) return `El rubro es muy largo (máximo ${MAX_QUERY} caracteres).`;
  if (c.length < MIN_CITY) return 'Escribe la ciudad.';
  if (c.length > MAX_CITY) return `La ciudad es muy larga (máximo ${MAX_CITY} caracteres).`;
  return null;
};

const STATUS = {
  pendiente: { label: 'En cola…', tone: 'text-amber-300' },
  procesando: { label: 'Analizando…', tone: 'text-amber-300' },
  listo: { label: 'Listo', tone: 'text-emerald-400' },
  error: { label: 'No se pudo hacer', tone: 'text-rose-300' },
  cancelado: { label: 'Cancelado', tone: 'text-seryi-text' }
};
export const reportStatus = (status) => STATUS[status] || { label: status || '—', tone: 'text-seryi-text' };
export const isRunning = (status) => status === 'pendiente' || status === 'procesando';

// Cifras del mercado en frases cortas para las fichas de la pantalla.
export const marketFacts = (market) => {
  if (!market) return [];
  const facts = [];
  if (Number.isFinite(market.encontrados)) facts.push({ label: 'Negocios encontrados', value: String(market.encontrados) });
  if (market.calificacion_promedio != null) facts.push({ label: 'Calificación promedio', value: String(market.calificacion_promedio) });
  if (market.resenas_mediana != null) facts.push({ label: 'Reseñas (típico)', value: String(market.resenas_mediana) });
  if (market.con_sitio_web_pct != null) facts.push({ label: 'Con sitio web', value: `${market.con_sitio_web_pct}%` });
  if (market.abren_domingo_pct != null) facts.push({ label: 'Abren domingo', value: `${market.abren_domingo_pct}%` });
  return facts;
};

export const ownLine = (market) => {
  const t = market?.tu_negocio;
  if (!t) return 'Tu negocio no aparece en estos resultados de Google Maps: crea o completa tu ficha para que te encuentren.';
  const rating = t.calificacion == null ? 'sin calificación' : `calificación ${t.calificacion}`;
  return `Tu negocio en Google Maps: ${rating}, ${t.resenas || 0} reseñas, ${t.sitio_web ? 'con' : 'sin'} sitio web.`;
};

export const yesNo = (v) => (v === null || v === undefined ? '—' : v ? 'Sí' : 'No');
